/**
 * @desc 获取待办任务
 */
const URL = "/rantion-activiti";
import http, { updateResponse } from "@/http";
export type Response = defs.activiti.ResponseDto<
  defs.activiti.PageInfo<defs.activiti.BusinessTaskResponseDto>
>;
export function request(
  params: API.activiti.business.getTaskListPage.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/business/task`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
